import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Transfer,
    message,
    Divider,
    Rate,
    Popover
} from 'antd';
import store from "../store/store.js";
import moment from 'moment';
import {Line, Column} from '@ant-design/charts';

const {Search} = Input;
const {Option} = Select;
const {RangePicker} = DatePicker;


class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {},
            data:[],
            visible: false,
        };
        this.mingpian = React.createRef();
        this.genjin = React.createRef();
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {
        this.getdata()
    }

    getdata() {
        let that = this
        let arr = this.state.condition
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        fetch('/Shouye/feiyong', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                console.log(data.type)
                if (!arr.type) {
                    let condition = Object.assign({}, this.state.condition, {type: data.type})
                    this.setState({
                        condition: condition
                    })
                }
                that.setState({
                    data: data.datalist.chart,
                    type_react: data.type_react ? data.type_react : []
                })
            })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
        setTimeout(() => {
            that.getdata()
        })
    }

    render() {
        const config = {
            style: {
                width: '100%'
            },
            animation: false,
            data: this.state.data ? this.state.data : [],
            isStack: true,
            xField: 'time',
            yField: 'value',
            seriesField: 'type',
            legend: {
                layout: 'horizontal',
                position: 'bottom'
            },

        };
        return (
            <>
                <div className={'box box6'}>
                    <div className={'title'}>
                        <div className={'p1'}>费用统计</div>
                        <div className={'p2'}>
                            <Select
                                style={{
                                    width: 120,
                                }}
                                placeholder="请选择"
                                value={this.state.condition.type ? this.state.condition.type : []}
                                onChange={this.onSelChange.bind(this, 'type')}
                                maxTagCount="responsive"
                                showSearch
                                optionFilterProp="children"
                                options={this.state.type_react ? this.state.type_react : null}
                            />
                        </div>
                    </div>
                    <Column {...config} />
                </div>
            </>
        )
    }
}

export default Index
